import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { InputTitle } from '../../../components';
import EditModal from './EditModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { selectLanguage } from '../../../redux/profileDataSlice';
import { deleteUserEmailAsync } from '../../../redux/userEmailDataSlice';
import { UserEmailModel, UserProfileModel } from '../../../models';
import { useAppDispatch, useAppSelector } from '../../../utils/hooks';
import { PROFILE_EDIT } from '../../../utils/config';
import styles from './EditEmail.module.css';
import { BaseButton, BaseHeader } from '../../../ui';

interface Interface {
  profile: UserProfileModel;
}

const EditEmail = ({ profile }: Interface) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const language = useAppSelector(selectLanguage);

  const handleBack = () => history.push(PROFILE_EDIT);

  const [viewAddModal, setViewAddModal] = useState(false);
  const handleToggleViewAddModal = () => setViewAddModal(!viewAddModal);

  const [deleteId, setDeleteId] = useState<number | undefined>();
  const handleViewDeleteModal = (id: number | undefined) => setDeleteId(id);
  const [editEmail, setEditEmail] = useState<UserEmailModel | undefined>();
  const handleViewEditModal = (id: number | undefined) =>
    setEditEmail(profile.emails.find((_) => _.id === id));

  const handleDelete = () => {
    deleteId &&
      dispatch(
        deleteUserEmailAsync({
          id: deleteId,
          userUuid: profile.userUuid,
        })
      );
    setDeleteId(undefined);
  };

  const handleCloseModal = () => {
    viewAddModal && setViewAddModal(false);
    editEmail && setEditEmail(undefined);
  };

  return (
    <>
      <BaseHeader title={language['EDIT_EMAIL']} showBack solidBackground />
      <div className={styles.root}>
        <div>
          {profile.emails.map((_, index) => (
            <React.Fragment key={_.id}>
              <InputTitle title={`Email ${index + 1}`} />
              <div className={styles.row}>
                <div className={styles.input} onClick={() => handleViewEditModal(_.id)}>
                  {_.email}
                </div>
                <IconButton color="warning" onClick={() => handleViewDeleteModal(_.id)}>
                  <DeleteOutlineIcon />
                </IconButton>
              </div>
            </React.Fragment>
          ))}
          <Button
            className={styles.button_transparent}
            variant="text"
            fullWidth
            onClick={handleToggleViewAddModal}>
            <div className={styles.button_inner}>
              <div className={styles.button_content}>
                <div className={styles.button_text}>{language['ADD_EMAIL']}</div>
                <ArrowForwardIosIcon className={styles.button_arrow} />
              </div>
            </div>
          </Button>
        </div>
        <BaseButton floating onClick={handleBack}>
          {language['BTN_APPLY']}
        </BaseButton>
      </div>
      {deleteId ? (
        <Dialog open={true} onClose={() => handleViewDeleteModal(undefined)}>
          <DialogTitle>{language['WANT_DELETE_EMAIL']}</DialogTitle>
          <DialogActions>
            <Button onClick={() => handleViewDeleteModal(undefined)}>{language['CANCEL']}</Button>
            <Button onClick={handleDelete} color="warning">
              {language['DELETE_STR']}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      {viewAddModal || editEmail ? (
        <EditModal onClose={handleCloseModal} email={editEmail} />
      ) : null}
    </>
  );
};

export default EditEmail;
